/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Add_On_ListInputs */

const en_quick_add_on_list = /** @type {(inputs: Quick_Add_On_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already on the list`)
};

const de_quick_add_on_list = /** @type {(inputs: Quick_Add_On_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schon auf der Liste`)
};

/**
* | output |
* | --- |
* | "Already on the list" |
*
* @param {Quick_Add_On_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_add_on_list = /** @type {((inputs?: Quick_Add_On_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Add_On_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_quick_add_on_list(inputs)
	return en_quick_add_on_list(inputs)
});